import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { teamCreateRouteRef } from './routes';

export const teamManagementPlugin = createPlugin({
  id: 'team-management',
  routes: {
    teamCreate: teamCreateRouteRef,
  },
});

export const TeamCreatePage = teamManagementPlugin.provide(
  createRoutableExtension({
    name: 'TeamCreatePage',
    component: () =>
      import('./components/TeamCreatePage/TeamCreatePage').then(
        m => m.TeamCreatePage,
      ),
    mountPoint: teamCreateRouteRef,
  }),
);
